import React, { createContext, useContext, useState } from "react";

export const QRCodeModalContext = createContext();

export function QRCodeModalProvider({ children }) {
    const [qrUrl, setQrUrl] = useState(null);
    const [route, setRoute] = useState();
    const [text, setText] = useState("");

    const showQRCodeModal = (url, route, text) => {
        setQrUrl(url);
        setRoute(route);
        setText(text);
    };
    const hideQRCodeModal = () => {
        setQrUrl(null);
        setRoute(null);
        setText("");
    };

    return (
        <QRCodeModalContext.Provider value={{ qrUrl, route, text, showQRCodeModal, hideQRCodeModal }}>
            {children}
        </QRCodeModalContext.Provider>
    );
}

export function useQRCodeModal() {
    return useContext(QRCodeModalContext);
}
